var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'app--login': _vm.isLoginRoute },style:({ color: _vm.COLORS.textPrimary, '--success': _vm.COLORS.success }),attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }